// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"adf753c1","498":"4f73eacf","513":"d7471184"}[chunkId] + ".chunk.js";
};